'use client';

import { useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { purchaseOrderApi, type PurchaseOrder } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';
import { NewPoDialog } from './NewPoDialog';

const PO_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  DRAFT: { bg: '#f0f0f0', text: '#888' },
  ORDERED: { bg: '#e8f3ff', text: '#3370ff' },
  PARTIAL_RECEIVED: { bg: '#fff7e8', text: '#ff7d00' },
  RECEIVED: { bg: '#e6fff0', text: '#0fc66e' },
  CLOSED: { bg: '#f7f8fa', text: '#8f959e' },
  CANCELLED: { bg: '#ffece8', text: '#f53f3f' },
};

export default function PurchaseOrdersPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <SimpleListPage<PurchaseOrder>
      key={refreshKey}
      title={rm.lists.purchaseOrders.title}
      description={rm.lists.purchaseOrders.description}
      load={async (p) => (await purchaseOrderApi.list(p)).items}
      searchPlaceholder={rm.lists.purchaseOrders.searchPlaceholder}
      toolbar={<NewPoDialog onCreated={() => setRefreshKey((k) => k + 1)} />}
      columns={[
        { key: 'poNo', label: rm.fields.poNo, width: '180px' },
        { key: 'sapPoNo', label: rm.fields.sapPoNo, width: '180px' },
        { key: 'status', label: rm.fields.status, width: '140px', render: (p) => {
          const c = PO_STATUS_COLORS[p.status] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={p.status} bg={c.bg} color={c.text} />;
        } },
        { key: 'totalAmount', label: rm.fields.amount, width: '120px', render: (p) => `${p.currencyCode} ${Number(p.totalAmount).toLocaleString()}` },
        { key: 'orderedAt', label: rm.fields.orderedAt, render: (p) => new Date(p.orderedAt).toLocaleDateString() },
        { key: 'expectedAt', label: rm.fields.expectedAt, render: (p) => p.expectedAt ? new Date(p.expectedAt).toLocaleDateString() : '-' },
        { key: '_count', label: rm.fields.linkedRobots, width: '120px', render: (p) => p._count?.robotUnits ?? 0 },
      ]}
    />
  );
}
